import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { MtmAuthBridgeService } from '@mtm/auth-ui-angular';
import { environment } from '@environments/environment';

export const appTokenInterceptor: HttpInterceptorFn = (req, next) => {
  // The app's own gateway, plus the admin gateway the accounts page's invite panel calls. Empty
  // bases are skipped: every URL starts with '' and would otherwise leave with the token.
  const signedBases = [environment.appApiUrl, environment.adminApiUrl].filter(Boolean);
  if (!signedBases.some((base) => req.url.startsWith(base))) {
    return next(req);
  }

  const token = inject(MtmAuthBridgeService).getAppTokenSync();

  if (!token) return next(req);

  return next(req.clone({ setHeaders: { Authorization: `Bearer ${token}` } }));
};
